import $ from 'jquery'

import sanitizer from '@app/adapters/sanitizer'

class UserSelect {
  static selector = "[data-behaviour~='user-select']"

  formatSelectionOnlyAvatar = (user) => $(user.text).filter('.avatar')
  formatSelectionFullText = (user) => user.text
  formatResult = (user) => user.text

  static init(selector = document, options = {}) {
    const settings = { onlyAvatar: true }

    options = $.extend(settings, options)
    const formatSelection = options.onlyAvatar
      ? UserSelect.formatSelectionOnlyAvatar
      : UserSelect.formatSelectionFullText

    $(selector)
      .find(UserSelect.selector)
      .select2({
        dropdownCssClass: 'user-select-dropdown',
        allowClear: true,
        width: 'copy',
        theme: 'silverfin',
        placeholder: 'no-one',
        formatResult: UserSelect.formatResult,
        formatSelection,
        escapeMarkup: (m) => sanitizer(m),
      })
      .on('open', () =>
        $(this).parents('[data-role~="hover-container"]').addClass('hover')
      )
  }
}

onDomLoad(($dom) => UserSelect.init($dom))
